import { withCurrencyConfiguration } from "config/currencyServer";
import { BusinessPage } from "screens/server/BusinessPage";
import "i18n";

export interface IAuth0User {
  email: string;
  id: string;
}

export interface ILoggedUser {
  isLoggedIn: boolean;
  avatar: string;
  isExpert: boolean;
  expertAvatar: string;
  fullName?: string;
}

const Home = ({
  user,
  acceptLanguageHeader,
  lang,
  subscriptionOffer,
  businessTitle,
  businessDescription,
  ogImage,
  twitterImage,
}) => {
  return (
    <BusinessPage
      user={user}
      acceptLanguageHeader={acceptLanguageHeader}
      lang={lang}
      subscriptionOffer={subscriptionOffer}
      businessTitle={businessTitle}
      businessDescription={businessDescription}
      ogImage={ogImage}
      twitterImage={twitterImage}
    />
  );
};

const getPageServerSideProps = async (context) => {
  const { query, req } = context;
  const cookies = req.cookies;
  const acceptLanguageHeader = req.headers["accept-language"] || null;
  const lang = cookies?.language || null;
  const r = query.r || null;

  //var ogImage = "https://waylight.me/img/waylightlinkinbiofbhq.png";
  //var twitterImage = "https://waylight.me/img/waylightlinkinbiotwitterhq.png";
  var ogImage = "https://waylight.me/img/waylightallinonefbhq.png";
  var twitterImage = "https://waylight.me/img/waylightallinonetwitterhq.png";
  //var businessTitle = "businessTitle";
  //var businessDescription = "businessDescription";
  var businessTitle = "businessTitleAll";
  var businessDescription = "businessDescriptionAll";

  switch (r) {
    case "SAMAIDA":
      ogImage = "https://waylight.me/img/waylightpaidtelegramfbhq.png";
      twitterImage =
        "https://waylight.me/img/waylightpaidtelegramtwitterhq.png";
      businessTitle = "businessTitle";
      businessDescription = "businessDescription";
      break;
    case "233":
      ogImage = "https://waylight.me/img/waylight233fbhq.jpg";
      twitterImage = "https://waylight.me/img/waylight233twitterhq.png";
      businessTitle = "businessTitle233";
      businessDescription = "businessDescription233";
      break;
    default:
      ogImage = "https://waylight.me/img/waylightallinonefbhq.png";
      twitterImage = "https://waylight.me/img/waylightallinonetwitterhq.png";
      //businessTitle = "businessTitle";
      //businessDescription = "businessDescription";
      businessTitle = "businessTitleAll";
      businessDescription = "businessDescriptionAll";
  }

  const user = await fetch(
    process.env.NEXT_PUBLIC_REST_URL + "/users/v1/users/me",
    {
      headers: {
        cookie: `access_token=${cookies?.access_token}; refresh_token=${cookies?.refresh_token}`,
      },
    }
  ).then((res) => res.json());

  let url = `/offers/v1/subscription-offer${!r ? "?currency=USD" : ""}${
    r
      ? `?r=${r}`
      : user?.expert?.referralCode
      ? `&r=${user?.expert?.referralCode}`
      : ""
  }`;

  const subscriptionOffer = await fetch(
    process.env.NEXT_PUBLIC_REST_URL + url
  ).then((res) => res.json());

  if (cookies.path && !user?.id) {
    return {
      redirect: {
        destination: `/sign-up${
          r
            ? `?r=${r}`
            : user?.expert?.referralCode
            ? `&r=${user?.expert?.referralCode}`
            : ""
        }`,
        permanent: false,
      },
    };
  }

  if (user?.id) {
    return {
      props: {
        user,
        acceptLanguageHeader,
        subscriptionOffer,
        businessTitle,
        businessDescription,
        ogImage,
        twitterImage,
      },
    };
  }

  return {
    props: {
      user: null,
      acceptLanguageHeader,
      lang,
      subscriptionOffer,
      businessTitle,
      businessDescription,
      ogImage,
      twitterImage,
    },
  };
};

export const getServerSideProps = withCurrencyConfiguration(
  getPageServerSideProps
);

export default Home;
